import React, { useEffect, useRef, useState } from "react";

import KpiCard from "../../../CommonComponents/Dashboard/KpiCard/KpiCard";
import { KPI_CARD_BACKGROUND } from "../../../../utils/Constants";

import "./stylesEventKpi.css";
import DashboardLineChart from "../../../CommonComponents/Dashboard/DashboardLineChart/DashboardLineChart";
import GeographicUserInsights from "../../../CommonComponents/Dashboard/GeographicUserInsights/GeographicUserInsights";
import BetTypes from "./BetTypes/BetTypes";
import MarketTypes from "./MarketTypes/MarketTypes";
import BettingActivity from "./BettingActivity/BettingActivity";
import BetStatuses from "./BetStatuses/BetStatuses";
import { Switch, Table } from "antd";
import createPrivateAdminPanelInstance from "../../../../api/PrivateAdminPanelInstance";
import { API_ROUTES } from "../../../../api/ApiRoutes";
import { useSearchParams } from "react-router-dom";
import { AppStrings } from "../../../../utils/constants/AppStrings";
import { useSelector } from "react-redux";

// formatCurrency will be defined inside the component to access appConfig

const formatWithPlus = (num) => {
  if (num == null || isNaN(num)) return "-";

  const hasDecimal = num % 1 !== 0;

  const formatted = Intl.NumberFormat("en-US", {
    minimumFractionDigits: hasDecimal ? 2 : 0,
    maximumFractionDigits: 2,
  }).format(num);

  return num > 0 ? `+${formatted}` : formatted;
};

const initialStates = [
  {
    name: "California",
    abbr: "CA",
    amount: 0,
  },
  {
    name: "Washington",
    abbr: "WA",
    amount: 0,
  },
  {
    name: "Texas",
    abbr: "TX",
    amount: 0,
  },
  {
    name: "Georgia",
    abbr: "GA",
    amount: 0,
  },
  {
    name: "Florida",
    abbr: "FL",
    amount: 0,
  },
  {
    name: "Minnesota",
    abbr: "MN",
    amount: 0,
  },
  {
    name: "Illinois",
    abbr: "IL",
    amount: 0,
  },
  {
    name: "Mississippi",
    abbr: "MS",
    amount: 0,
  },
  {
    name: "Alabama",
    abbr: "AL",
    amount: 0,
  },
  {
    name: "South Carolina",
    abbr: "SC",
    amount: 0,
  },
  {
    name: "Wisconsin",
    abbr: "WI",
    amount: 0,
  },
  {
    name: "Missouri",
    abbr: "MO",
    amount: 0,
  },
  {
    name: "North Carolina",
    abbr: "NC",
    amount: 0,
  },
  {
    name: "Pennsylvania",
    abbr: "PA",
    amount: 0,
  },
  {
    name: "Virginia",
    abbr: "VA",
    amount: 0,
  },
  {
    name: "Oregon",
    abbr: "OR",
    amount: 0,
  },
  {
    name: "Massachusetts",
    abbr: "MA",
    amount: 0,
  },
  {
    name: "Ohio",
    abbr: "OH",
    amount: 0,
  },
  {
    name: "Utah",
    abbr: "UT",
    amount: 0,
  },
  {
    name: "Oklahoma",
    abbr: "OK",
    amount: 0,
  },
  {
    name: "Tennessee",
    abbr: "TN",
    amount: 0,
  },
  {
    name: "Indiana",
    abbr: "IN",
    amount: 0,
  },
  {
    name: "Colorado",
    abbr: "CO",
    amount: 0,
  },
  {
    name: "Hawaii",
    abbr: "HI",
    amount: 0,
  },
  {
    name: "Kentucky",
    abbr: "KY",
    amount: 0,
  },
  {
    name: "Arkansas",
    abbr: "AR",
    amount: 0,
  },
  {
    name: "Kansas",
    abbr: "KS",
    amount: 0,
  },
  {
    name: "Iowa",
    abbr: "IA",
    amount: 0,
  },
  {
    name: "Nebraska",
    abbr: "NE",
    amount: 0,
  },
  {
    name: "New Mexico",
    abbr: "NM",
    amount: 0,
  },
  {
    name: "South Dakota",
    abbr: "SD",
    amount: 0,
  },
  {
    name: "New Hampshire",
    abbr: "NH",
    amount: 0,
  },
  {
    name: "North Dakota",
    abbr: "ND",
    amount: 0,
  },
  {
    name: "Rhode Island",
    abbr: "RI",
    amount: 0,
  },
  {
    name: "West Virginia",
    abbr: "WV",
    amount: 0,
  },
  {
    name: "Delaware",
    abbr: "DE",
    amount: 0,
  },
  {
    name: "Maine",
    abbr: "ME",
    amount: 0,
  },
  {
    name: "Alaska",
    abbr: "AK",
    amount: 0,
  },
  {
    name: "Washington, D.C.",
    abbr: "DC",
    amount: 0,
  },
  {
    name: "Wyoming",
    abbr: "WY",
    amount: 0,
  },
  {
    name: "Vermont",
    abbr: "VT",
    amount: 0,
  },
  {
    name: "Connecticut",
    abbr: "CT",
    amount: 0,
  },
  {
    name: "New York",
    abbr: "NY",
    amount: 0,
  },
];

function EventKpi() {
  const storedToken = localStorage.getItem("token");
  const token = storedToken ? JSON.parse(storedToken) : null;
  const PrivateAdminPanelInstance = createPrivateAdminPanelInstance(
    token?.AccessToken?.trim() || token?.AccessToken,
    false
  );

  const [searchParams] = useSearchParams();
  const eventId = searchParams.get("event-id");

  const { appConfig } = useSelector((state) => state.config);
  const country = appConfig?.app_currency_config?.country;
  const defaultCurrency = appConfig?.app_currency_config?.default_currency || "USD";
  
  const formatCurrency = (value) => {
    return Intl.NumberFormat("en-US", {
      style: "currency",
      currency: defaultCurrency,
    }).format(value);
  };
  
  const [isApiRunning, setIsApiRunning] = useState(false);

  const containerRef = useRef(null);

  const [fixedHeader, setFixedHeader] = useState(true);

  const [eventKpis, setEventKpis] = useState({
    profitAndLoss: 0,
    margin: 0,
    cashOutProfitAndLoss: 0,
    turnover: 0,
    playersEngaged: 0,
    repeatBettors: 0,
    avgBetAmount: 0,
  });

  const [eventKpiLineChartData, setEventKpiLineChartData] = useState({
    labels: [],

    datasets: [
      {
        label: "Total bets",
        data: [],
        backgroundColor: ["#EE72BC"],
        borderColor: ["#EE72BC"],
        borderWidth: 1,
        borderRadius: 4,
      },
    ],
    headers: [
      { title: "Total bets", amount: 0 },
      { title: "Straight", amount: 0 },
      { title: "Parlay", amount: 0 },
    ],
  });

  const [usersByStateData, setUsersByStateData] = useState(initialStates);

  const [bettingData, setBettingData] = useState([
    {
      name: "Accepted Bets",
      totalBets: "",
      straightBets: "",
      parlayBets: "",
      flexBets: "",
      roundRobinBets: "",
    },
    {
      name: "Rejected Bets",
      totalBets: "",
      straightBets: "",
      parlayBets: "",
      flexBets: "",
      roundRobinBets: "",
    },
    {
      name: "Cancelled Bets",
      totalBets: "",
      straightBets: "",
      parlayBets: "",
      flexBets: "",
      roundRobinBets: "",
    },
    {
      name: "% of Winning Bets",
      totalBets: "",
      straightBets: "",
      parlayBets: "",
      flexBets: "",
      roundRobinBets: "",
    },
    {
      name: "% Live",
      totalBets: "",
      straightBets: "",
      parlayBets: "",
      flexBets: "",
      roundRobinBets: "",
    },
    {
      name: "Unsettled Bets",
      totalBets: "",
      straightBets: "",
      parlayBets: "",
      flexBets: "",
      roundRobinBets: "",
    },
  ]);

  const [profitabilityData, setProfitabilityData] = useState([
    {
      name: "Total Stake",
      totalBets: "",
      straightBets: "",
      parlayBets: "",
      flexBets: "",
      roundRobinBets: "",
    },
    {
      name: "Unsettled Stakes",
      totalBets: "",
      straightBets: "",
      parlayBets: "",
      flexBets: "",
      roundRobinBets: "",
    },
    {
      name: "Net P/L",
      totalBets: "",
      straightBets: "",
      parlayBets: "",
      flexBets: "",
      roundRobinBets: "",
    },
    {
      name: "Margin",
      totalBets: "",
      straightBets: "",
      parlayBets: "",
      flexBets: "",
      roundRobinBets: "",
    },
    {
      name: "Earning per Bet",
      totalBets: "",
      straightBets: "",
      parlayBets: "",
      flexBets: "",
      roundRobinBets: "",
    },
    {
      name: "Average Stake",
      totalBets: "",
      straightBets: "",
      parlayBets: "",
      flexBets: "",
      roundRobinBets: "",
    },
  ]);

  const [oddsData, setOddsData] = useState([
    {
      name: "Highest Odds",
      totalBets: "",
      straightBets: "",
      parlayBets: "",
      flexBets: "",
      roundRobinBets: "",
    },
    {
      name: "Lowest Odds",
      totalBets: "",
      straightBets: "",
      parlayBets: "",
      flexBets: "",
      roundRobinBets: "",
    },
    {
      name: "Avg Odds",
      totalBets: "",
      straightBets: "",
      parlayBets: "",
      flexBets: "",
      roundRobinBets: "",
    },
  ]);

  const [winningsOddsData, setWinningsOddsData] = useState([
    {
      name: "Highest Winn. Odds",
      totalBets: "",
      straightBets: "",
      parlayBets: "",
      flexBets: "",
      roundRobinBets: "",
    },
    {
      name: "Lowest Winn. Odds",
      totalBets: "",
      straightBets: "",
      parlayBets: "",
      flexBets: "",
      roundRobinBets: "",
    },
    {
      name: "Avg Highest Winn. Odds",
      totalBets: "",
      straightBets: "",
      parlayBets: "",
      flexBets: "",
      roundRobinBets: "",
    },
  ]);

  const bettingColumns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      width: 200,
    },
    {
      title: "Total Bets",
      dataIndex: "totalBets",
      key: "totalBets",
      width: 200,
    },
    {
      title: "Straight Bets",
      dataIndex: "straightBets",
      key: "straightBets",
      width: 200,
    },
    {
      title: "Parlay Bets",
      dataIndex: "parlayBets",
      key: "parlayBets",
      width: 200,
    },
    {
      title: "Flex Bets",
      dataIndex: "flexBets",
      key: "flexBets",
      width: 200,
    },
    {
      title: "Round Robin",
      dataIndex: "roundRobinBets",
      key: "roundRobinBets",
      width: 200,
    },
  ];
  const profitabilityColumns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      width: 200,
    },
    {
      title: "Total Bets",
      dataIndex: "totalBets",
      key: "totalBets",
      width: 200,
    },
    {
      title: "Straight Bets",
      dataIndex: "straightBets",
      key: "straightBets",
      width: 200,
    },
    {
      title: "Parlay Bets",
      dataIndex: "parlayBets",
      key: "parlayBets",
      width: 200,
    },
    {
      title: "Flex Bets",
      dataIndex: "flexBets",
      key: "flexBets",
      width: 200,
    },
    {
      title: "Round Robin",
      dataIndex: "roundRobinBets",
      key: "roundRobinBets",
      width: 200,
    },
  ];
  const oddsColumns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      width: 200,
    },
    {
      title: "Total Bets",
      dataIndex: "totalBets",
      key: "totalBets",
      width: 200,
    },
    {
      title: "Straight Bets",
      dataIndex: "straightBets",
      key: "straightBets",
      width: 200,
    },
    {
      title: "Parlay Bets",
      dataIndex: "parlayBets",
      key: "parlayBets",
      width: 200,
    },
    {
      title: "Flex Bets",
      dataIndex: "flexBets",
      key: "flexBets",
      width: 200,
    },
    {
      title: "Round Robin",
      dataIndex: "roundRobinBets",
      key: "roundRobinBets",
      width: 200,
    },
  ];
  const winningsOddsColumns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      width: 200,
    },
    {
      title: "Total Bets",
      dataIndex: "totalBets",
      key: "totalBets",
      width: 200,
    },
    {
      title: "Straight Bets",
      dataIndex: "straightBets",
      key: "straightBets",
      width: 200,
    },
    {
      title: "Parlay Bets",
      dataIndex: "parlayBets",
      key: "parlayBets",
      width: 200,
    },
    {
      title: "Flex Bets",
      dataIndex: "flexBets",
      key: "flexBets",
      width: 200,
    },
    {
      title: "Round Robin",
      dataIndex: "roundRobinBets",
      key: "roundRobinBets",
      width: 200,
    },
  ];

  const getEvenDetailsKpiData = async () => {
    if (!token?.AccessToken || !eventId) {
      console.error("Missing token or event ID");
      setIsApiRunning(false);
      return;
    }

    setIsApiRunning(true);
    try {
      const requests = [
        PrivateAdminPanelInstance.post(API_ROUTES.GET_EVENT_DETAILS_KPI_TABLE, {
          event_id: eventId,
        }),
        PrivateAdminPanelInstance.post(
          API_ROUTES.GET_EVENT_DETAILS_KPI_DAILY_HISTOGRAM,
          {
            event_id: eventId,
          }
        ),
        PrivateAdminPanelInstance.post(
          API_ROUTES.GET_EVENT_DETAILS_KPI_OVERVIEW,
          {
            event_id: eventId,
          }
        ),
        PrivateAdminPanelInstance.post(
          API_ROUTES.GET_EVENT_DETAILS_KPI_USER_STATE_MAP,
          {
            event_id: eventId,
          }
        ),
      ];

      const responses = await Promise.allSettled(requests);
      const [
        kpiTableResponse,
        kpiDailyHistogramResponse,
        kpiOverviewResponse,
        kpiUserStateMapResponse,
      ] = responses;

      if (kpiTableResponse.status === "fulfilled") {
        const data = kpiTableResponse?.value?.data?.data || {};

        console.log("data kpi Table", data);

        const bettingData = [
          {
            name: "Accepted Bets",
            totalBets: `${data.total?.betting?.accepted?.value ?? 0} (${data.total?.betting?.accepted?.percentage ?? 0}%)`,
            straightBets: `${data.straight?.betting?.accepted?.value ?? 0} (${data.straight?.betting?.accepted?.percentage ?? 0}%)`,
            parlayBets: `${data.parlay?.betting?.accepted?.value ?? 0} (${data.parlay?.betting?.accepted?.percentage ?? 0}%)`,
            flexBets: `${data.flex?.betting?.accepted?.value ?? 0} (${data.flex?.betting?.accepted?.percentage ?? 0}%)`,
            roundRobinBets: `${data.round_robin?.betting?.accepted?.value ?? 0} (${data.round_robin?.betting?.accepted?.percentage ?? 0}%)`,
          },
          {
            name: "Rejected Bets",
            totalBets: `${data.total?.betting?.rejected?.value ?? 0} (${data.total?.betting?.rejected?.percentage ?? 0}%)`,
            straightBets: `${data.straight?.betting?.rejected?.value ?? 0} (${data.straight?.betting?.rejected?.percentage ?? 0}%)`,
            parlayBets: `${data.parlay?.betting?.rejected?.value ?? 0} (${data.parlay?.betting?.rejected?.percentage ?? 0}%)`,
            flexBets: `${data.flex?.betting?.rejected?.value ?? 0} (${data.flex?.betting?.rejected?.percentage ?? 0}%)`,
            roundRobinBets: `${data.round_robin?.betting?.rejected?.value ?? 0} (${data.round_robin?.betting?.rejected?.percentage ?? 0}%)`,
          },
          {
            name: "Cancelled Bets",
            totalBets: `${data.total?.betting?.cancelled?.value ?? 0} (${data.total?.betting?.cancelled?.percentage ?? 0}%)`,
            straightBets: `${data.straight?.betting?.cancelled?.value ?? 0} (${data.straight?.betting?.cancelled?.percentage ?? 0}%)`,
            parlayBets: `${data.parlay?.betting?.cancelled?.value ?? 0} (${data.parlay?.betting?.cancelled?.percentage ?? 0}%)`,
            flexBets: `${data.flex?.betting?.cancelled?.value ?? 0} (${data.flex?.betting?.cancelled?.percentage ?? 0}%)`,
            roundRobinBets: `${data.round_robin?.betting?.cancelled?.value ?? 0} (${data.round_robin?.betting?.cancelled?.percentage ?? 0}%)`,
          },
          {
            name: "% of Winning Bets",
            totalBets: `${data.total?.betting?.winning?.value ?? 0} (${data.total?.betting?.winning?.percentage ?? 0}%)`,
            straightBets: `${data.straight?.betting?.winning?.value ?? 0} (${data.straight?.betting?.winning?.percentage ?? 0}%)`,
            parlayBets: `${data.parlay?.betting?.winning?.value ?? 0} (${data.parlay?.betting?.winning?.percentage ?? 0}%)`,
            flexBets: `${data.flex?.betting?.winning?.value ?? 0} (${data.flex?.betting?.winning?.percentage ?? 0}%)`,
            roundRobinBets: `${data.round_robin?.betting?.winning?.value ?? 0} (${data.round_robin?.betting?.winning?.percentage ?? 0}%)`,
          },
          {
            name: "% Live",
            totalBets: `${data.total?.betting?.live?.value ?? 0} (${data.total?.betting?.live?.percentage ?? 0}%)`,
            straightBets: `${data.straight?.betting?.live?.value ?? 0} (${data.straight?.betting?.live?.percentage ?? 0}%)`,
            parlayBets: `${data.parlay?.betting?.live?.value ?? 0} (${data.parlay?.betting?.live?.percentage ?? 0}%)`,
            flexBets: `${data.flex?.betting?.live?.value ?? 0} (${data.flex?.betting?.live?.percentage ?? 0}%)`,
            roundRobinBets: `${data.round_robin?.betting?.live?.value ?? 0} (${data.round_robin?.betting?.live?.percentage ?? 0}%)`,
          },
          {
            name: "Unsettled Bets",
            totalBets: `${data.total?.betting?.unsettled?.value ?? 0} (${data.total?.betting?.unsettled?.percentage ?? 0}%)`,
            straightBets: `${data.straight?.betting?.unsettled?.value ?? 0} (${data.straight?.betting?.unsettled?.percentage ?? 0}%)`,
            parlayBets: `${data.parlay?.betting?.unsettled?.value ?? 0} (${data.parlay?.betting?.unsettled?.percentage ?? 0}%)`,
            flexBets: `${data.flex?.betting?.unsettled?.value ?? 0} (${data.flex?.betting?.unsettled?.percentage ?? 0}%)`,
            roundRobinBets: `${data.round_robin?.betting?.unsettled?.value ?? 0} (${data.round_robin?.betting?.unsettled?.percentage ?? 0}%)`,
          },
        ];

        const profitabilityData = [
          {
            name: "Total Stake",
            totalBets: formatCurrency(data.total?.profitability?.total_stake ?? 0),
            straightBets: formatCurrency(
              data.straight?.profitability?.total_stake ?? 0
            ),
            parlayBets: formatCurrency(data.parlay?.profitability?.total_stake ?? 0),
            flexBets: formatCurrency(data.flex?.profitability?.total_stake ?? 0),
            roundRobinBets: formatCurrency(data.round_robin?.profitability?.total_stake ?? 0),
          },
          {
            name: "Unsettled Stakes",
            totalBets: formatCurrency(data.total?.profitability?.unsettled_stake ?? 0),
            straightBets: formatCurrency(
              data.straight?.profitability?.unsettled_stake ?? 0
            ),
            parlayBets: formatCurrency(
              data.parlay?.profitability?.unsettled_stake ?? 0
            ),
            flexBets: formatCurrency(data.flex?.profitability?.unsettled_stake ?? 0),
            roundRobinBets: formatCurrency(data.round_robin?.profitability?.unsettled_stake ?? 0),
          },
          {
            name: "Net P/L",
            totalBets: formatCurrency(data.total?.profitability?.net_profit_loss ?? 0),
            straightBets: formatCurrency(
              data.straight?.profitability?.net_profit_loss ?? 0
            ),
            parlayBets: formatCurrency(
              data.parlay?.profitability?.net_profit_loss ?? 0
            ),
            flexBets: formatCurrency(data.flex?.profitability?.net_profit_loss ?? 0),
            roundRobinBets: formatCurrency(data.round_robin?.profitability?.net_profit_loss ?? 0),
          },
          {
            name: "Margin",
            totalBets: `${data.total?.profitability?.margin ?? 0}%`,
            straightBets: `${data.straight?.profitability?.margin ?? 0}%`,
            parlayBets: `${data.parlay?.profitability?.margin ?? 0}%`,
            flexBets: `${data.flex?.profitability?.margin ?? 0}%`,
            roundRobinBets: `${data.round_robin?.profitability?.margin ?? 0}%`,
          },
          {
            name: "Earning per Bet",
            totalBets: formatCurrency(
              data.total?.profitability?.earnings_per_bet ?? 0
            ),
            straightBets: formatCurrency(
              data.straight?.profitability?.earnings_per_bet ?? 0
            ),
            parlayBets: formatCurrency(
              data.parlay?.profitability?.earnings_per_bet ?? 0
            ),
            flexBets: formatCurrency(data.flex?.profitability?.earnings_per_bet ?? 0),
            roundRobinBets: formatCurrency(data.round_robin?.profitability?.earnings_per_bet ?? 0),
          },
          {
            name: "Average Stake",
            totalBets: formatCurrency(data.total?.profitability?.average_stake ?? 0),
            straightBets: formatCurrency(
              data.straight?.profitability?.average_stake ?? 0
            ),
            parlayBets: formatCurrency(data.parlay?.profitability?.average_stake ?? 0),
            flexBets: formatCurrency(data.flex?.profitability?.average_stake ?? 0),
            roundRobinBets: formatCurrency(data.round_robin?.profitability?.average_stake ?? 0),
          },
        ];
        const oddsData = [
          {
            name: "Highest Odds",
            totalBets: formatWithPlus(data.total?.odds?.all?.highest ?? 0),
            straightBets: formatWithPlus(data.straight?.odds?.all?.highest ?? 0),
            parlayBets: formatWithPlus(data.parlay?.odds?.all?.highest ?? 0),
            flexBets: formatWithPlus(data.flex?.odds?.all?.highest ?? 0),
            roundRobinBets: formatWithPlus(data.round_robin?.odds?.all?.highest ?? 0),
          },
          {
            name: "Lowest Odds",
            totalBets: formatWithPlus(data.total?.odds?.all?.lowest ?? 0),
            straightBets: formatWithPlus(data.straight?.odds?.all?.lowest ?? 0),
            parlayBets: formatWithPlus(data.parlay?.odds?.all?.lowest ?? 0),
            flexBets: formatWithPlus(data.flex?.odds?.all?.lowest ?? 0),
            roundRobinBets: formatWithPlus(data.round_robin?.odds?.all?.lowest ?? 0),
          },
          {
            name: "Avg Odds",
            totalBets: formatWithPlus(data.total?.odds?.all?.average ?? 0),
            straightBets: formatWithPlus(data.straight?.odds?.all?.average ?? 0),
            parlayBets: formatWithPlus(data.parlay?.odds?.all?.average ?? 0),
            flexBets: formatWithPlus(data.flex?.odds?.all?.average ?? 0),
            roundRobinBets: formatWithPlus(data.round_robin?.odds?.all?.average ?? 0),
          },
        ];
        const winningsOddsData = [
          {
            name: "Highest Winn. Odds",
            totalBets: formatWithPlus(data.total?.odds?.winning?.highest ?? 0),
            straightBets: formatWithPlus(data.straight?.odds?.winning?.highest ?? 0),
            parlayBets: formatWithPlus(data.parlay?.odds?.winning?.highest ?? 0),
            flexBets: formatWithPlus(data.flex?.odds?.winning?.highest ?? 0),
            roundRobinBets: formatWithPlus(data.round_robin?.odds?.winning?.highest ?? 0),
          },
          {
            name: "Lowest Winn. Odds",
            totalBets: formatWithPlus(data.total?.odds?.winning?.lowest ?? 0),
            straightBets: formatWithPlus(data.straight?.odds?.winning?.lowest ?? 0),
            parlayBets: formatWithPlus(data.parlay?.odds?.winning?.lowest ?? 0),
            flexBets: formatWithPlus(data.flex?.odds?.winning?.lowest ?? 0),
            roundRobinBets: formatWithPlus(data.round_robin?.odds?.winning?.lowest ?? 0),
          },
          {
            name: "Avg Highest Winn. Odds",
            totalBets: formatWithPlus(data.total?.odds?.winning?.average ?? 0),
            straightBets: formatWithPlus(data.straight?.odds?.winning?.average ?? 0),
            parlayBets: formatWithPlus(data.parlay?.odds?.winning?.average ?? 0),
            flexBets: formatWithPlus(data.flex?.odds?.winning?.average ?? 0),
            roundRobinBets: formatWithPlus(data.round_robin?.odds?.winning?.average ?? 0),
          },
        ];
        setBettingData(bettingData);
        setProfitabilityData(profitabilityData);
        setOddsData(oddsData);
        setWinningsOddsData(winningsOddsData);
      }

      if (kpiDailyHistogramResponse.status === "fulfilled") {
        const dailyHistogramData =
          kpiDailyHistogramResponse?.value?.data?.data?.data || [];

        console.log("dailyHistogramData", dailyHistogramData);
        const headers = dailyHistogramData.header;
        const graph = dailyHistogramData.graph;

        setEventKpiLineChartData({
          labels: Object.keys(graph.total),
          datasets: [
            {
              label: "Total Bets",
              data: Object.values(graph.total),
              backgroundColor: ["#EE72BC"],
              borderColor: ["#EE72BC"],
              borderWidth: 1,
              borderRadius: 1,
            },
          ],
          headers: [
            { title: "Total Bets", amount: headers.total.value },
            { title: "Straight", amount: headers.straight.value },
            { title: "Parlay", amount: headers.parlay.value },
          ],
        });
      }

      if (kpiOverviewResponse.status === "fulfilled") {
        const data = kpiOverviewResponse?.value?.data?.data || {};

        setEventKpis({
          profitAndLoss: data.profit_loss,
          margin: data.margin,
          cashOutProfitAndLoss: data.cashout_pl,
          turnover: data.turnover,
          playersEngaged: data.players_engaged.value,
          repeatBettors: data.repeat_bettors.value,
          avgBetAmount: data.average_bet_amount.value,
        });
      }

      if (kpiUserStateMapResponse.status === "fulfilled") {
        const data = kpiUserStateMapResponse?.value?.data?.data?.data || [];

        const states = [
          ...initialStates.map((stateItem) => {
            const match = data.find((item) => item.state === stateItem.name);
            return {
              ...stateItem,
              amount: match ? match.count : stateItem.amount,
            };
          }),

          ...data
            .filter((item) => !initialStates.some((s) => s.name === item.state))
            .map((item) => ({
              name: item.state,
              abbr: item.state,
              amount: item.count,
            })),
        ];


        setUsersByStateData(states);
      }
    } catch (error) {
      console.log("Error getting event details kpi data:", error);
    } finally {
      setIsApiRunning(false);
    }
  };

  useEffect(() => {
    getEvenDetailsKpiData();
  }, []);

  return (
    <div className="event-kpi-container">
      <div className="event-kpi-top">
        <KpiCard
          isApiRunning={isApiRunning}
          title={"Profit & Loss"}
          value={eventKpis.profitAndLoss}
          hugeValue={false}
          rate={false}
          percentage={false}
          backgroundColor={KPI_CARD_BACKGROUND.DARK}
        />
        <KpiCard
          isApiRunning={isApiRunning}
          title={"Margin"}
          value={eventKpis.margin}
          hugeValue={false}
          rate={true}
          percentage={false}
          backgroundColor={KPI_CARD_BACKGROUND.DARK}
        />
        <KpiCard
          isApiRunning={isApiRunning}
          title={"Cash Out Profit and Loss"}
          value={eventKpis.cashOutProfitAndLoss}
          customColor={false}
          hugeValue={false}
          percentage={false}
          backgroundColor={KPI_CARD_BACKGROUND.DARK}
        />
        <KpiCard
          isApiRunning={isApiRunning}
          title="Turnover"
          value={eventKpis.turnover}
          hugeValue={true}
          percentage={false}
          backgroundColor={KPI_CARD_BACKGROUND.TRASNPARENT}
        />
      </div>
      <div className="event-kpi-middle">
        <div className="event-kpi-middle-left">
          <DashboardLineChart
            data={eventKpiLineChartData}
            showCustomDatePicker={false}
            headers={eventKpiLineChartData.headers}
            isApiRunning={isApiRunning}
            setSelected={() => {}}
            customOptions={[]}
            rightInfo={false}
          />
        </div>
        <div className="event-kpi-middle-right">
          <GeographicUserInsights
            mapId="users-by-state-left-content-event-kpi"
            country={country}
            data={usersByStateData}
            isDollars={false}
            title="Users by State"
          />
        </div>
      </div>
      <div className="event-kpi-bottom">
        <KpiCard
          isApiRunning={isApiRunning}
          title="Players Engaged"
          value={eventKpis.playersEngaged}
          maximumFractionDigits={0}
          hugeValue={false}
          percentage={false}
          backgroundColor={KPI_CARD_BACKGROUND.DARK}
        />
        <KpiCard
          isApiRunning={isApiRunning}
          title={"REPEAT BETTORS"}
          value={eventKpis.repeatBettors}
          maximumFractionDigits={0}
          minimumFractionDigits={0}
          hugeValue={false}
          percentage={false}
          backgroundColor={KPI_CARD_BACKGROUND.DARK}
        />
        <KpiCard
          isApiRunning={isApiRunning}
          title={"Avg Bet Amount"}
          value={eventKpis.avgBetAmount}
          hugeValue={false}
          percentage={false}
          isMoney={true}
          backgroundColor={KPI_CARD_BACKGROUND.DARK}
        />
      </div>
      <div className="event-kpi-table-container" ref={containerRef}>
        <div className="event-kpi-table-container-item">
          <h3>{AppStrings.BETTING}</h3>
          {fixedHeader && (
            <div className="custom-fixed-header">
              <Table
                columns={bettingColumns}
                pagination={false}
                showHeader={true}
                locale={{ emptyText: <span style={{ display: "none" }} /> }}
              />
            </div>
          )}
          <Table
            columns={bettingColumns}
            dataSource={bettingData}
            pagination={false}
            scroll={{ x: 1000 }}
            showHeader={false}
          />
        </div>
        <div className="event-kpi-table-container-item">
          <h3>{AppStrings.PROFITABILITY}</h3>
          {fixedHeader && (
            <div className="custom-fixed-header">
              <Table
                columns={profitabilityColumns}
                pagination={false}
                showHeader={true}
                locale={{ emptyText: <span style={{ display: "none" }} /> }}
              />
            </div>
          )}
          <Table
            columns={profitabilityColumns}
            dataSource={profitabilityData}
            pagination={false}
            scroll={{ x: 1000 }}
            showHeader={false}
          />
        </div>
        <div className="event-kpi-table-container-item">
          <h3>{AppStrings.ODDS}</h3>
          {fixedHeader && (
            <div className="custom-fixed-header">
              <Table
                columns={oddsColumns}
                pagination={false}
                showHeader={true}
                locale={{ emptyText: <span style={{ display: "none" }} /> }}
              />
            </div>
          )}
          <Table
            columns={oddsColumns}
            dataSource={oddsData}
            pagination={false}
            showHeader={false}
            scroll={{ x: 1000 }}
          />
        </div>
        <div className="event-kpi-table-container-item">
          <h3>{AppStrings.WINNINGS_ODDS}</h3>
          {fixedHeader && (
            <div className="custom-fixed-header">
              <Table
                columns={winningsOddsColumns}
                pagination={false}
                showHeader={true}
                locale={{ emptyText: <span style={{ display: "none" }} /> }}
              />
            </div>
          )}
          <Table
            columns={winningsOddsColumns}
            dataSource={winningsOddsData}
            scroll={{ x: 1000 }}
            showHeader={false}
            pagination={false}
          />
        </div>
      </div>
      <div
        className="event-kpi-row"
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <BetTypes />
        <MarketTypes />
      </div>
      <div
        className="event-kpi-row"
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <BettingActivity />
        <BetStatuses />
      </div>
    </div>
  );
}

export default EventKpi;
